import type { PropsWithChildren } from 'react';
import React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { HeroLayout } from '@change/ds-core-ui/HeroLayout';
import { Link } from '@change/ds-core-ui/Link';
import { Separator } from '@change/ds-core-ui/Separator';
import { Text } from '@change/ds-core-ui/Text';
import { ArrowRightIcon } from '@change/ds-icons/ArrowRightIcon';

import { Translate } from '@change-corgi/core-react/i18n';

import { capitalizeTopic } from '#src/app/shared/utils/topic';

export type MostSignedProps = PropsWithChildren<{
	title: string;
	description: string;
}>;

export const MostSigned: React.FC<MostSignedProps> = ({ children, title, description }) => {
	return (
		<HeroLayout
			data-qa="most-signed-container"
			media={
				<div className="bg-background-raised text-typography-strong h-full w-full space-y-6 rounded-l-2xl p-4 *:block sm:p-12">
					<Text as="h2" variant="heading" size="small" data-qa="most-signed-heading">
						{title}
					</Text>
					<Text>{description}</Text>
				</div>
			}
			variant="1/3"
		>
			<div className="max-md:pt-4 max-md:pb-6 md:px-4 md:py-1">{children}</div>
		</HeroLayout>
	);
};

export type MostSignedListItemProps = {
	title: string;
	signatureCount: string;
	link: string;
};

export const MostSignedListItem: React.FC<MostSignedListItemProps> = ({ title, signatureCount, link }) => {
	return (
		<div className="[&_hr]:last:hidden">
			<Link
				href={link}
				data-qa="most-signed-topic-button"
				variant="secondary"
				underline={false}
				className="[&>span]:fex-row group w-full cursor-pointer items-center p-4 [&>span]:flex [&>span]:w-full [&>span]:justify-between"
			>
				<div className="space-y-1">
					<Text
						data-qa="most-signed-topic"
						variant="heading"
						fontWeight="light"
						as="h3"
						size="small"
						className="group-hover:underline"
					>
						{capitalizeTopic(title)}
					</Text>

					<Text size="small" className="pl-0">
						• <b>{signatureCount}</b> <Translate value="corgi.local.top_tags.people_signed" />
					</Text>
				</div>
				<Button
					onClick={() => {}}
					variant="secondary"
					iconOnly
					leadingIcon={<ArrowRightIcon />}
					aria-label="open"
					size="small"
					as="div"
					className="group-hover:bg-fill-hover pointer-events-none box-content h-6 w-5 shrink-0 p-3"
				/>
			</Link>
			<Separator className="border-stroke-weaker my-0" />
		</div>
	);
};
